module.exports = __webpack_public_path__ + "img/expectations.9d520088.jpg";